import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EventEmitter } from '@angular/core';

@Component({
  selector: 'app-form-approval-dialog',
  templateUrl: './form-approval-dialog.component.html',
  styleUrls: ['./form-approval-dialog.component.scss'],
  standalone: false,
})
export class FormApprovalDialogComponent implements OnInit {
  onYes = new EventEmitter();
  submitting = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<FormApprovalDialogComponent>
  ) {}

  ngOnInit() {}

  closeDialog() {
    this.dialogRef.close();
  }

  saveAndClose() {
    if (this.submitting) return;
    this.submitting = true;
    this.onYes.emit();
    this.dialogRef.close();
  }
}
